import React from 'react'
import Layout from '../components/Layout'
import SupportForm from '../components/SupportForm'

const support = () => {
   return (
      <Layout>
         <SupportForm/>
      </Layout>
   )
}

export default support
